module.exports = __webpack_public_path__ + "img/square-root-variable.98f712df.svg";